import { ChartArea } from "chart.js/types/geometric";
import config from "@/config";

export function getGradient(ctx: CanvasRenderingContext2D, chartArea: ChartArea, startColor: string, endColor: string) {
  let gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
  gradient.addColorStop(0, startColor);
  gradient.addColorStop(1, endColor);
  return gradient;
}

export function normalizeNumber(n: number): string | number | null {
  if (n > 0 && n < 1) return null;
  return n < 1000
    ? n.toString()
    : Intl.NumberFormat(config.locale, {
        style: "decimal",
        useGrouping: true,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(n / 1000) + "k";
}
